import axios from '@/axios';

const RESOURCE_NAME = '/admin/crawl-ecosystems';

export default {
    getList(data) {
        return axios.post(`${RESOURCE_NAME}/get-list`, data)
    }
}
